import React from "react";

import { useLanguage } from "@/contexts/LanguageContext.jsx";
import { getPasswordRequirementStatus } from "@/features/security/passwordPolicy.js";

export default function PasswordRequirementChecklist({ password = "", className = "" }) {
  const { t } = useLanguage();
  const status = getPasswordRequirementStatus(password);
  const items = [
    {
      key: "uppercase",
      passed: status.uppercase,
      label: t("settings.password.requirementUppercase", "Uppercase"),
    },
    {
      key: "lowercase",
      passed: status.lowercase,
      label: t("settings.password.requirementLowercase", "Lowercase"),
    },
    {
      key: "number",
      passed: status.number,
      label: t("settings.password.requirementNumber", "Number"),
    },
    {
      key: "symbol",
      passed: status.symbol,
      label: t("settings.password.requirementSymbol", "Symbol"),
    },
    {
      key: "minLength",
      passed: status.minLength,
      label: t("settings.password.requirementMinLength", "Minimum 8 characters"),
    },
  ];

  return (
    <div
      className={`text-body-small ${className}`.trim()}
      aria-live="polite"
      aria-label={t("settings.password.requirementsLabel", "Password requirements")}
    >
      <p className="font-medium text-on-surface">
        {t("settings.password.strongHelpTitle", "Use a strong password")}
      </p>
      <ul className="mt-1 grid gap-1 sm:grid-cols-2">
        {items.map((item) => (
          <li
            key={item.key}
            className={
              item.passed
                ? "flex items-center gap-2 text-[#17803b]"
                : "flex items-center gap-2 text-on-surface-var"
            }
          >
            <span aria-hidden="true" className="inline-flex w-4 justify-center">
              {item.passed ? "✓" : "○"}
            </span>
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
